(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[954],{

/***/ 19686:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/overseas",
      function () {
        return __webpack_require__(89284);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 89284:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSP": function() { return /* binding */ __N_SSP; },
/* harmony export */   "default": function() { return /* export default binding */ __WEBPACK_DEFAULT_EXPORT__; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var styled_jsx_style__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(60357);
/* harmony import */ var styled_jsx_style__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(styled_jsx_style__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var _components_pagelay__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(28082);
/* harmony import */ var _utils_useHead__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(25838);
/* harmony import */ var _utils_useRequest__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(54013);
/* harmony import */ var _index_module_scss__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(68267);
/* harmony import */ var _index_module_scss__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(_index_module_scss__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(93967);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var next_intl__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(81627);
/* harmony import */ var swiper_css__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(25194);
/* harmony import */ var swiper_css__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(swiper_css__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var swiper_css_pagination__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(18700);
/* harmony import */ var swiper_css_pagination__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(swiper_css_pagination__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var swiper_css_navigation__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(94375);
/* harmony import */ var swiper_css_navigation__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(swiper_css_navigation__WEBPACK_IMPORTED_MODULE_10__);













var __N_SSP = true;
/* harmony default export */ function __WEBPACK_DEFAULT_EXPORT__(param) {
    var navDetail = param.navDetail;
    var ref;
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_7__.useRouter)();
    var request = (0,_utils_useRequest__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)();
    var t = (0,next_intl__WEBPACK_IMPORTED_MODULE_11__/* .useTranslations */ .T_)();
    var tabList = (0,react__WEBPACK_IMPORTED_MODULE_2__.useMemo)(function() {
        return [
            {
                id: 1,
                title: t("overseas.tab1"),
                list: [
                    {
                        id: 1,
                        title: t("overseas.item1.title", {
                            th: "<sup>th</sup>"
                        }),
                        text: t("overseas.item1.text", {
                            th: "<sup>th</sup>"
                        }),
                        time: t("overseas.item1.time"),
                        address: t("overseas.item1.address"),
                        cover: "/image/overseas/image1.png",
                        link: "https://www.powtex.com/tokyo/"
                    },
                    {
                        id: 2,
                        title: t("overseas.item2.title"),
                        text: t("overseas.item2.text"),
                        time: t("overseas.item2.time"),
                        address: t("overseas.item2.address"),
                        cover: "/image/overseas/image2.png",
                        link: "https://www.apowdertech.com/"
                    },
                    {
                        id: 3,
                        title: t("overseas.item3.title"),
                        text: t("overseas.item3.text"),
                        time: t("overseas.item3.time"),
                        address: t("overseas.item3.address"),
                        cover: "/image/overseas/image3.png",
                        link: "https://unitedchemicalshow.com/en/for-exhibitors/booking-of-participation "
                    },
                    {
                        id: 4,
                        title: t("overseas.item4.title"),
                        text: t("overseas.item4.text"),
                        time: t("overseas.item4.time"),
                        address: t("overseas.item4.address"),
                        cover: "/image/overseas/image4.png",
                        link: "https://chemexpo-vietnam.com/"
                    }, 
                ]
            },
            {
                id: 2,
                title: t("overseas.tab2"),
                list: [
                    {
                        id: 5,
                        title: t("overseas.item5.title"),
                        text: t("overseas.item5.text"),
                        time: t("overseas.item5.time"),
                        address: t("overseas.item5.address"),
                        cover: "/image/overseas/image5.png",
                        link: "https://www.powtech.de/en"
                    },
                    {
                        id: 6,
                        title: t("overseas.item6.title"),
                        text: t("overseas.item6.text"),
                        time: t("overseas.item6.time"),
                        address: t("overseas.item6.address"),
                        cover: "/image/overseas/image6.png",
                        link: "https://home.analiticanet.com.br/"
                    },
                    {
                        id: 7,
                        title: t("overseas.item7.title"),
                        text: t("overseas.item7.text"),
                        time: t("overseas.item7.time"),
                        address: t("overseas.item7.address"),
                        cover: "/image/overseas/image7.png",
                        link: "https://fcecosmetique.com.br/"
                    },
                    {
                        id: 8,
                        title: t("overseas.item8.title"),
                        text: t("overseas.item8.text"),
                        time: t("overseas.item8.time"),
                        address: t("overseas.item8.address"),
                        cover: "/image/overseas/image8.png",
                        link: "https://fcepharma.com.br/"
                    },
                    {
                        id: 9,
                        title: t("overseas.item9.title"),
                        text: t("overseas.item9.text"),
                        time: t("overseas.item9.time"),
                        address: t("overseas.item9.address"),
                        cover: "/image/overseas/image9.png",
                        link: "https://foodtech.gr/en/"
                    },
                    {
                        id: 10,
                        title: t("overseas.item10.title"),
                        text: t("overseas.item10.text"),
                        time: t("overseas.item10.time"),
                        address: t("overseas.item10.address"),
                        cover: "/image/overseas/image10.png",
                        link: "https://www.partec.info/en"
                    }, 
                ]
            }, 
        ];
    }, [
        router.locale
    ]);
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(1), currentTab = ref1[0], setCurrentTab = ref1[1];
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_pagelay__WEBPACK_IMPORTED_MODULE_3__/* .PageLayout */ .X, {
        title: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h1", {
                    style: {
                        fontSize: "36px"
                    },
                    children: router.locale === "cn" ? "IPB 2027 第二十四届国际粉体、散料、流体加工展览会" : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                        children: [
                            "24",
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("sup", {
                                children: "rd"
                            }),
                            " International Processing Trade Fair for Powder, Bulk Solids and Fluids"
                        ]
                    })
                }, router.pathname),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                    style: {
                        fontSize: "24px",
                        fontWeight: "normal"
                    },
                    children: t("common.time")
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                    style: {
                        fontSize: "24px",
                        fontWeight: "normal"
                    },
                    children: t("common.site")
                })
            ]
        }),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: "jsx-6c9b5c68836e9127" + " " + ((_index_module_scss__WEBPACK_IMPORTED_MODULE_12___default().container) || ""),
            children: [
                (0,_utils_useHead__WEBPACK_IMPORTED_MODULE_4__/* .getHead */ .c)(navDetail),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "jsx-6c9b5c68836e9127" + " " + ((_index_module_scss__WEBPACK_IMPORTED_MODULE_12___default().content) || ""),
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("ul", {
                            className: "jsx-6c9b5c68836e9127" + " " + ((_index_module_scss__WEBPACK_IMPORTED_MODULE_12___default().tab) || ""),
                            children: tabList.map(function(item) {
                                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                    onClick: function() {
                                        return setCurrentTab(item.id);
                                    },
                                    className: "jsx-6c9b5c68836e9127" + " " + (classnames__WEBPACK_IMPORTED_MODULE_6___default()([
                                        (_index_module_scss__WEBPACK_IMPORTED_MODULE_12___default().item),
                                        item.id === currentTab && (_index_module_scss__WEBPACK_IMPORTED_MODULE_12___default().active)
                                    ]) || ""),
                                    children: item.title
                                }, item.id);
                            })
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("ul", {
                            className: "jsx-6c9b5c68836e9127" + " " + ((_index_module_scss__WEBPACK_IMPORTED_MODULE_12___default().list) || ""),
                            children: (ref = tabList.find(function(item) {
                                return item.id === currentTab;
                            })) === null || ref === void 0 ? void 0 : ref.list.map(function(item) {
                                /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                    className: "jsx-6c9b5c68836e9127" + " " + ((_index_module_scss__WEBPACK_IMPORTED_MODULE_12___default().item) || ""),
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                        className: "jsx-6c9b5c68836e9127" + " " + ((_index_module_scss__WEBPACK_IMPORTED_MODULE_12___default().inner) || ""),
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                className: "jsx-6c9b5c68836e9127" + " " + ((_index_module_scss__WEBPACK_IMPORTED_MODULE_12___default().left) || ""),
                                                children: [
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                        dangerouslySetInnerHTML: {
                                                            __html: item.title
                                                        },
                                                        className: "jsx-6c9b5c68836e9127" + " " + ((_index_module_scss__WEBPACK_IMPORTED_MODULE_12___default().title) || "")
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                        className: "jsx-6c9b5c68836e9127" + " " + ((_index_module_scss__WEBPACK_IMPORTED_MODULE_12___default().sub) || ""),
                                                        children: [
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                                className: "jsx-6c9b5c68836e9127" + " " + ((_index_module_scss__WEBPACK_IMPORTED_MODULE_12___default().time) || ""),
                                                                children: item.time
                                                            }),
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                                className: "jsx-6c9b5c68836e9127" + " " + ((_index_module_scss__WEBPACK_IMPORTED_MODULE_12___default().address) || ""),
                                                                children: item.address
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                        dangerouslySetInnerHTML: {
                                                            __html: item.text
                                                        },
                                                        className: "jsx-6c9b5c68836e9127" + " " + ((_index_module_scss__WEBPACK_IMPORTED_MODULE_12___default().text) || "")
                                                    }),
                                                    (item === null || item === void 0 ? void 0 : item.link) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                                        href: item.link,
                                                        target: "_blank",
                                                        className: "jsx-6c9b5c68836e9127" + " " + ((_index_module_scss__WEBPACK_IMPORTED_MODULE_12___default().link) || ""),
                                                        children: t("overseas.check")
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                className: "jsx-6c9b5c68836e9127" + " " + ((_index_module_scss__WEBPACK_IMPORTED_MODULE_12___default().right) || ""),
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                                    src: item.cover,
                                                    alt: item.title,
                                                    className: "jsx-6c9b5c68836e9127" + " " + ((_index_module_scss__WEBPACK_IMPORTED_MODULE_12___default().cover) || "")
                                                })
                                            })
                                        ]
                                    })
                                }, item.id);
                            })
                        })
                    ]
                }),
                (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((styled_jsx_style__WEBPACK_IMPORTED_MODULE_1___default()), {
                    id: "6c9b5c68836e9127",
                    children: ""
                })
            ]
        })
    });
};


/***/ }),

/***/ 25838:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "c": function() { return /* binding */ getHead; }
/* harmony export */ });
/* unused harmony export getServerSideProps */
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(97582);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _utils_request__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(45844);





var getServerSideProps = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(function(context) {
        var ref, data;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_4__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        _utils_request__WEBPACK_IMPORTED_MODULE_2__/* ["default"].get */ .Z.get("/getHomeMenuDetail", {
                            params: {
                                path: context === null || context === void 0 ? void 0 : (ref = context.resolvedUrl) === null || ref === void 0 ? void 0 : ref.split("?")[0]
                            },
                            headers: {
                                lang: (context === null || context === void 0 ? void 0 : context.locale) || "cn"
                            }
                        })
                    ];
                case 1:
                    data = _state.sent().data;
                    return [
                        2,
                        {
                            props: {
                                navDetail: data.data || null,
                                menuDetail: data.data || null
                            }
                        }
                    ];
            }
        });
    });
    return function getServerSideProps(context) {
        return _ref.apply(this, arguments);
    };
}();
var getHead = function(menuDetail) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)((next_head__WEBPACK_IMPORTED_MODULE_1___default()), {
        children: [
            (menuDetail === null || menuDetail === void 0 ? void 0 : menuDetail.meta_title) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("title", {
                children: [
                    menuDetail === null || menuDetail === void 0 ? void 0 : menuDetail.meta_title,
                    " "
                ]
            }),
            (menuDetail === null || menuDetail === void 0 ? void 0 : menuDetail.meta_kws) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "keywords",
                content: menuDetail === null || menuDetail === void 0 ? void 0 : menuDetail.meta_kws
            }),
            (menuDetail === null || menuDetail === void 0 ? void 0 : menuDetail.meta_desc) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "description",
                content: menuDetail === null || menuDetail === void 0 ? void 0 : menuDetail.meta_desc
            })
        ]
    });
};



/***/ }),

/***/ 68267:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"m-1480":"overseas_m-1480__n3PtJ","container":"overseas_container__HYWnP","content":"overseas_content__zkpMV","tab":"overseas_tab__7t_Lu","item":"overseas_item__qr5kU","active":"overseas_active__duBcF","list":"overseas_list__rAjHP","inner":"overseas_inner__PT_Y9","left":"overseas_left__Na2cn","title":"overseas_title__esGU8","sub":"overseas_sub__St7SQ","time":"overseas_time__mUwwD","address":"overseas_address__zmJyi","text":"overseas_text__vqPd6","link":"overseas_link__ljmWM","cover":"overseas_cover__dYvH4","right":"overseas_right__ZrivA"};

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [222,912,774,888,179], function() { return __webpack_exec__(19686); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);